import { LocalStorage } from "quasar";

export default () => {
  const filterSymbolData = (rows, filterSymbol) => {
    const filterValue = filterSymbol.toLowerCase();
    const regex = filterValue
      ? new RegExp(`^${filterValue}(?!\\S)`, "i")
      : null;
    return rows.filter((row) => (regex ? regex.test(row.symbol) : true));
  };

  const filterBulkData = (rows, filterQuery) => {
    const { symbol, buyer, seller } = filterQuery;
    const symbolRegex = symbol
      ? new RegExp(`^${symbol.toLowerCase()}(?!\\S)`, "i")
      : null;

    return rows.filter((row) => {
      const matchesSymbol =
        !symbol || symbolRegex.test(row.symbol.toLowerCase());
      const matchesBuyer =
        !buyer || row.buyer?.toLowerCase() === buyer?.toLowerCase();
      const matchesSeller =
        !seller || row.seller?.toLowerCase() === seller?.toLowerCase();

      return matchesSymbol && matchesBuyer && matchesSeller;
    });
  };

  const amountConversion = (value) => {
    if (value == null || isNaN(value)) {
      return " ";
    }

    var val = Math.abs(value);
    var sign = value < 0 ? "-" : "";
    if (val >= 100000000000) {
      val = (val / 100000000000).toFixed(2) + " Kharab";
    } else if (val >= 1000000000) {
      val = (val / 1000000000).toFixed(2) + " Arab";
    } else if (val >= 10000000) {
      val = (val / 10000000).toFixed(2) + " Cr";
    } else if (val >= 100000) {
      val = (val / 100000).toFixed(2) + " Lac";
    } else if (val >= 1000) {
      val = (val / 1000).toFixed(2) + " K";
    } else {
      val = val.toFixed(2);
    }
    return sign + val;
  };

  const getFromToDate = (as_of) => {
    let to_date = as_of.replaceAll("/", "-");
    let from_date = new Date(
      new Date(to_date).setFullYear(new Date(to_date).getFullYear() - 1)
    )
      .toISOString()
      .substring(0, 10);
    return {
      from_date: from_date,
      to_date: to_date,
    };
  };

  const dateToWeekRange = (date) => {
    const currentDate = new Date();
    const dateToCompare = new Date(date);

    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(currentDate.getDate() - currentDate.getDay());

    dateToCompare.setHours(0, 0, 0, 0);
    dateToCompare.setDate(dateToCompare.getDate() - dateToCompare.getDay());

    const millisecondsInAWeek = 1000 * 60 * 60 * 24 * 7;

    return Math.max(
      1,
      Math.floor((currentDate - dateToCompare) / millisecondsInAWeek) + 1
    );
  };

  const getTopTurnOverVolume = (res) => {
    let topTurnovers = res
      .map((item) => {
        return {
          symbol: item.symbol,
          amount: item.amount,
          close: item.close,
        };
      })
      .sort((a, b) => b.amount - a.amount);
    let topVolumes = res
      .map((item) => {
        return {
          symbol: item.symbol,
          volume: item.volume,
          close: item.close,
        };
      })
      .sort((a, b) => b.volume - a.volume);
    return { topTurnovers: topTurnovers, topVolumes: topVolumes };
  };

  const getTopGainersLoosers = (res) => {
    return {
      topGainers: res
        .filter((item) => item.percentage_change > 0)
        .sort((b, a) => a.percentage_change - b.percentage_change),
      topLoosers: res
        .filter((item) => item.percentage_change < 0)
        .sort((b, a) => b.percentage_change - a.percentage_change),
    };
  };

  const getAllSectors = () => [
    { id: 25, symbol: "NEPSE", name: "Nepse", description: "Nepse" },
    { id: 1, symbol: "BANKINGIND", name: "Banking", description: "Banking" },
    {
      id: 2,
      symbol: "DEVBANKIND",
      name: "Dev Banks",
      description: "Devlopment Banks",
    },
    { id: 3, symbol: "FINANCEIND", name: "Finance", description: "Finance" },
    { id: 4, symbol: "HOTELIND", name: "Hotels", description: "Hotels" },
    { id: 5, symbol: "HYDROPOWIND", name: "Hydro", description: "Hydropower" },
    { id: 6, symbol: "INVIDX", name: "Investment", description: "Investment" },
    {
      id: 7,
      symbol: "LIFEINSUIND",
      name: "Life Insu",
      description: "Life Insurance",
    },
    {
      id: 8,
      symbol: "MANUFACTUREIND",
      name: "Manufacture",
      description: "Manufacturing And Processing",
    },
    {
      id: 9,
      symbol: "MICROFININD",
      name: "Microfinance",
      description: "Microfinance",
    },
    {
      id: 10,
      symbol: "NONLIFEIND",
      name: "Non Life",
      description: "Non Life Insurance",
    },
    { id: 11, symbol: "OTHERSIND", name: "Others", description: "Others" },
    { id: 12, symbol: "TRADINGIND", name: "Trading", description: "Tradings" },
    {
      id: 13,
      symbol: "MUTUALIND",
      name: "MutualFund",
      description: "Mutual Fund",
    },
  ];

  const oneMonthAgoStrDate = (date) => {
    date = new Date(date);
    date.setMonth(date.getMonth() - 1);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const nMonthAgoStrDate = (date, n) => {
    date = new Date(date);
    date.setMonth(date.getMonth() - n);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const oneDayAgoStrDate = (date) => {
    date = new Date(date);
    date.setDate(date.getDate() - 1);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const nDayAgoStrDate = (date, n) => {
    date = new Date(date);
    date.setDate(date.getDate() - n);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const utilsOptionSectors = () => [
    {
      id: 0,
      symbol: "All Sectors",
      name: "All Sectors",
      label: "All Sectors",
    },
    { id: 1, symbol: "BANKING", name: "Banking" },
    { id: 2, symbol: "DEVBANK", name: "Dev Banks" },
    { id: 3, symbol: "FINANCE", name: "Finance" },
    { id: 4, symbol: "HOTELS", name: "Hotels" },
    { id: 5, symbol: "HYDRO", name: "Hydropower" },
    { id: 6, symbol: "INVESTMENT", name: "Investment" },
    { id: 7, symbol: "LIFEINSU", name: "Life Insurance" },
    { id: 8, symbol: "MANUFACTURE", name: "Manufacturing" },
    { id: 9, symbol: "MICROFINANCE", name: "Microfinance" },
    { id: 10, symbol: "NONLIFEINSU", name: "NonLife" },
    { id: 11, symbol: "OTHERS", name: "Others" },
    { id: 12, symbol: "TRDIND", name: "Tradings" },
    { id: 13, symbol: "MUTUAL", name: "Mutual Fund" },
  ];

  const allIndexs = () => [
    {
      id: 19,
      name: "Hotels",
      symbol: "HOTELIND",
      active: true,
      description: "All the companies Listed in Hotels Group",
      base_market_cap: 1731.2836,
      created_at: "2022-04-25T18:50:54.420483+05:45",
      updated_at: "2022-04-25T19:36:46.461185+05:45",
    },
    {
      id: 22,
      name: "Dev Banks",
      symbol: "DEVBANKIND",
      active: true,
      description: "Index of the listed development Banks",
      base_market_cap: 3666.4353,
      created_at: "2022-04-25T18:50:54.528575+05:45",
      updated_at: "2022-04-25T19:36:46.600503+05:45",
    },
    {
      id: 24,
      name: "Sensitive",
      symbol: "SENSIND",
      active: true,
      description: "Sensitive Index",
      base_market_cap: 300391.8737,
      created_at: "2022-04-25T18:50:54.683052+05:45",
      updated_at: "2022-04-25T19:36:46.681277+05:45",
    },
    {
      id: 20,
      name: "Others",
      symbol: "OTHERSIND",
      active: true,
      description: "All the companies Listed in Others Group",
      base_market_cap: 16655.773,
      created_at: "2022-04-25T18:50:54.439362+05:45",
      updated_at: "2022-04-25T19:36:46.499312+05:45",
    },
    {
      id: 34,
      name: "Investment",
      symbol: "INVIDX",
      active: true,
      description: "All Investment Index",
      base_market_cap: 306617.1843,
      created_at: "2022-04-25T18:50:54.989961+05:45",
      updated_at: "2022-04-25T19:36:47.127306+05:45",
    },
    {
      id: 25,
      name: "Nepse",
      symbol: "NEPSE",
      active: true,
      description: "All Equity Index",
      base_market_cap: 142249.3672,
      created_at: "2022-04-25T18:50:54.726722+05:45",
      updated_at: "2022-04-25T19:36:46.703187+05:45",
    },
    {
      id: 29,
      name: "Float",
      symbol: "FLOATIND",
      active: true,
      description: "All Float Index",
      base_market_cap: 728158.6452,
      created_at: "2022-04-25T18:50:54.823664+05:45",
      updated_at: "2022-04-25T19:36:46.923374+05:45",
    },
    {
      id: 30,
      name: "Sensitive Float",
      symbol: "SENSFLTIND",
      active: true,
      description: "All Sensitive Float Index",
      base_market_cap: 332174.6441,
      created_at: "2022-04-25T18:50:54.848469+05:45",
      updated_at: "2022-04-25T19:36:46.948151+05:45",
    },
    {
      id: 33,
      name: "Mutual Fund",
      symbol: "MUTUALIND",
      active: true,
      description: "All Mutual Fund Index",
      base_market_cap: 23241.6305,
      created_at: "2022-04-25T18:50:54.971336+05:45",
      updated_at: "2022-04-25T19:36:47.071801+05:45",
    },
    {
      id: 18,
      name: "Banking",
      symbol: "BANKINGIND",
      active: true,
      description: "Index of All the Listed Commercial Banks",
      base_market_cap: 77303.8132,
      created_at: "2022-04-25T18:50:54.385426+05:45",
      updated_at: "2022-04-25T19:36:46.395123+05:45",
    },
    {
      id: 31,
      name: "Microfinance",
      symbol: "MICROFININD",
      active: true,
      description: "all microfinance company index",
      base_market_cap: 7444.8602,
      created_at: "2022-04-25T18:50:54.879505+05:45",
      updated_at: "2022-04-25T19:36:46.992031+05:45",
    },
    {
      id: 26,
      name: "Non Life ",
      symbol: "NONLIFEIND",
      active: true,
      description: "All Non Life Insurance Index",
      base_market_cap: 1896.2657,
      created_at: "2022-04-25T18:50:54.757596+05:45",
      updated_at: "2022-04-25T19:36:46.752490+05:45",
    },
    {
      id: 32,
      name: "Life Insurance",
      symbol: "LIFEINSUIND",
      active: true,
      description: "All Life Insurance Index",
      base_market_cap: 2204.8811,
      created_at: "2022-04-25T18:50:54.919266+05:45",
      updated_at: "2022-04-25T19:36:47.036942+05:45",
    },
    {
      id: 23,
      name: "Manufacturing",
      symbol: "MANUFACTUREIND",
      active: true,
      description: "Manufacturing and Processing Index",
      base_market_cap: 2425.9019,
      created_at: "2022-04-25T18:50:54.661717+05:45",
      updated_at: "2022-04-25T19:36:46.661797+05:45",
    },
    {
      id: 27,
      name: "Finance",
      symbol: "FINANCEIND",
      active: true,
      description: "Index of Finance Companies",
      base_market_cap: 3195.5842,
      created_at: "2022-04-25T18:50:54.777202+05:45",
      updated_at: "2022-04-25T19:36:46.804494+05:45",
    },
    {
      id: 28,
      name: "Trading",
      symbol: "TRADINGIND",
      active: true,
      description: "All Trading Companies",
      base_market_cap: 582.072,
      created_at: "2022-04-25T18:50:54.794755+05:45",
      updated_at: "2022-04-25T19:36:46.891968+05:45",
    },
    {
      id: 21,
      name: "Hydro",
      symbol: "HYDROPOWIND",
      active: true,
      description: "All the companies listed in Hydropower Group",
      base_market_cap: 13056.0876,
      created_at: "2022-04-25T18:50:54.484557+05:45",
      updated_at: "2022-04-25T19:36:46.554562+05:45",
    },
  ];

  const trueCandelStickData = {
    Bullish: {
      "Bullish Spinning Top": { name: "Bullish Spinning Top" },
      "Bullish Pin Bar": { name: "Bullish Pin Bar" },
      "Bullish Kicker": { name: "Bullish Kicker" },
      "Bullish Engulfing": { name: "Bullish Engulfing" },
      "Bullish Fractal": { name: "Bullish Fractal" },
      "Morning Star": { name: "Morning Star" },
      "Three White Soldiers": { name: "Three White Solders" },
      "Inverted Hammer": { name: "Inverted Hammer" },
      Hammer: { name: "Hammer" },
      Piercing: { name: "Piercing" },
      "Three Inside Up": { name: "Three Inside Up" },
    },
    Bearish: {
      "Bearish Spinning Top": { name: "Bearish Spinning Top" },
      "Bearish Pin Bar": { name: "Bearish Pin Bar" },
      "Bearish Kicker": { name: "Bearish Kicker" },
      "Bearish Engulfing": { name: "Bearish Engulfing" },
      "Bearish Fractal": { name: "Bearish Fractal" },
      "Evening Star": { name: "Evening Star" },
      "Three Black Crows": { name: "Three Black Crows" },
      "Hanging Man": { name: "Hanging Man" },
      "Shooting Star": { name: "Shooting Star" },
      "Dark Cloud Cover": { name: "Dark Cloud Cover" },
      "Three Down Pattern": { name: "Three Down Pattern" },
    },
  };

  const candelStickData = {
    Bullish: {
      "Bullish Spinning Top": { name: "Bullish Spinning Top" },
      "Bullish Pin Bar": { name: "Bullish Pin Bar" },
      "Bullish Kicker": { name: "Bullish Kicker" },
      "Bullish Engulfing": { name: "Bullish Engulfing" },
      "Morning Star": { name: "Morning Star" },
      "Three White Soldiers": { name: "Three White Soldiers" },
      "Inverted Hammer": { name: "Inverted Hammer" },
      Hammer: { name: "Hammer" },
      "Piercing Line": { name: "Piercing Line" },
      "Three Inside Up": { name: "Three Inside Up" },
    },
    Bearish: {
      "Bearish Spinning Top": { name: "Bearish Spinning Top" },
      "Bearish Pin Bar": { name: "Bearish Pin Bar" },
      "Bearish Kicker": { name: "Bearish Kicker" },
      "Bearish Engulfing": { name: "Bearish Engulfing" },
      "Evening Star": { name: "Evening Star" },
      "Three Black Crows": { name: "Three Black Crows" },
      "Hanging Man": { name: "Hanging Man" },
      "Shooting Star": { name: "Shooting Star" },
      "Dark Cloud Cover": { name: "Dark Cloud Cover" },
      "Three Side Down": { name: "Three Side Down" },
    },
  };

  const chooseTabColor = (darkMode, hostname) => {
    let stateDomains = LocalStorage.getItem("stateDomains");
    if (stateDomains != null) {
      const {
        chukul,
        prabhu,
        demo,
        demo1,
        globalimecapital,
        arthasarokar,
        dev,
        sweta,
      } = stateDomains;

      if (darkMode === true) {
        return "grey-7";
      } else {
        if (hostname == demo1 || hostname == sweta) {
          return "bg-blue-grey-10 text-white table-sticky-header-column-dark-sweta";
        }
        if (hostname == arthasarokar) {
          return "bg-green-9 text-white ";
        }
        if (hostname == chukul || hostname == "localhost" || hostname == dev)
          return "table-sticky-header-column";
        if (hostname == prabhu)
          return "bg-red text-white table-sticky-header-column-dark-prabhu";
        if (hostname == arthasarokar) return "";
      }
    }
  };

  const chooseActiveTabColor = (darkMode, hostname) => {
    if (darkMode === true) {
      return "grey-7";
    } else {
      let stateDomains = LocalStorage.getItem("stateDomains");
      if (stateDomains != null) {
        const {
          chukul,
          prabhu,
          demo,
          demo1,
          globalimecapital,
          arthasarokar,
          dev,
          sweta,
        } = stateDomains;
        if (hostname == demo1 || hostname == sweta) return "blue-grey-9";
        if (hostname == chukul || hostname == "localhost" || hostname == dev)
          return "blue-5";
        if (hostname == prabhu) return "red";
        if (hostname == arthasarokar) return "green";
      }
    }
  };

  const getUniqueFiscalYears = (data) => {
    const fiscalYears = new Set();
    data.forEach((item) => {
      fiscalYears.add(item.fiscal_year);
    });
    return Array.from(fiscalYears);
  };

  const form = {
    source: "close",
    condition: ">",
    time_period: "daily",
    logic: "and",
    scanning_type: "Fresh",
  };
  const optionTimePeriod = [
    "half_hourly",
    "hourly",
    "daily",
    "weekly",
    "monthly",
  ];
  const optionScanningType = ["Fresh", "Already", "Hybrid"];
  const optionSource = ["open", "high", "low", "close", "adj_close"];
  const optionLogic = ["and", "or"];
  const optionCondition = ["<", ">"];

  const months = {
    1: "Baishakh",
    2: "Jestha",
    3: "Asar",
    4: "Shrawan",
    5: "Bhadra",
    6: "Aswin",
    7: "Kartik",
    8: "Mangsir",
    9: "Poush",
    10: "Magh",
    11: "Falgun",
    12: "Chaitra",
  };

  return {
    nDayAgoStrDate,
    oneMonthAgoStrDate,
    nMonthAgoStrDate,
    oneDayAgoStrDate,
    filterSymbolData,
    filterBulkData,
    getFromToDate,
    utilsOptionSectors,
    getTopTurnOverVolume,
    getTopGainersLoosers,
    getAllSectors,
    amountConversion,
    candelStickData,
    trueCandelStickData,
    allIndexs,
    chooseTabColor,
    chooseActiveTabColor,
    dateToWeekRange,
    getUniqueFiscalYears,
    form,
    optionTimePeriod,
    optionScanningType,
    optionSource,
    optionLogic,
    optionCondition,
    months,
  };
};
